<template>
  <b-card no-body class="p-0 m-0 banner-card">
    <b-card-body class="m-0 p-0">
      <div class="d-flex flex-column justify-content-center align-items-center text-center">
        <img class="adjust-conte" src="@/assets/lottie/check-mark.gif" style="width: 30em" />
        <p class="font-weight-boldest display-4">Email Berhasil Diverifikasi.</p>
        <p class="font-size-h3">Selamat Bekerja Bersama Grower Management System - Salam Hangat <strong>Team Developer</strong></p>
        
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="Relogin()"
          class="mr-3"
        >
          <i class="ri-login-circle-line"></i> Login Ulang
        </b-button>
      </div>
    </b-card-body>
  </b-card>

</template> 
<script>
import "./login/login.scss";
import _ from "lodash";
import axios from "axios";
import mode from "@/mode.js";
export default {
  name: "login-page",
  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {
    Relogin(){
      this.$router.push({ path: "/login" });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/default-page/email-verified.vue